export const SUPPORTED_CURRENCIES = ['USD', 'EUR', 'RUB', 'CNY', 'KZT']

// Shown instead of a rate value when the API has no data for it.
export const RATE_PLACEHOLDER = '—'
